import React, { useEffect, useRef, useMemo, useState } from 'react';
import * as d3 from 'd3';

const desktopCharWidth = {
  H: 26,
  A: 32,
  P: 19,
  Y: 25,
  B: 22,
  I: 14,
  R: 24,
  T: 39,
  D: 22,
  S: 14,
  N: 30,
  L: 23,
  O: 20,
  V: 29,
  E: 25,
  U: 19,
};

const mobileCharWidth = {
  I: 8,
  L: 14,
  O: 12,
  V: 17,
  E: 15,
  Y: 15,
  U: 11,
  H: 15,
  A: 19,
  P: 12,
  B: 13,
  R: 15,
  T: 23,
  D: 13,
  S: 8,
  N: 18,
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return isMobile;
};

export const BirthdayGreeting = () => {
  const isMobile = useIsMobile();
  const svgRef = useRef(null);
  const animationRef = useRef(null);
  const gridRef = useRef(null);

  const colors = useMemo(
    () => [
      { main: '#FF6B6B', light: '#FFB3B3' },
      { main: '#4ECDC4', light: '#A6E9E3' },
      { main: '#45B7D1', light: '#9AD9E9' },
      { main: '#FFA07A', light: '#FFCEB3' },
      { main: '#98D8C8', light: '#C9EDE4' },
    ],
    [],
  );
  const tColors = useMemo(
    () => [
      '#FFC0CB',
      // '#FF033E',
      // '#E6E6FA',
      // '#DC143C',
      // '#FFDAB9',
      '#E0B0FF',
      '#FFA07A',
      '#F7E7CE',
      '#DCAE96',
      // '#8E4585'
    ],
    [],
  );
  const rColors = useMemo(
    () => [
      '#FFC0CB',
      '#FF033E',
      '#E6E6FA',
      '#DC143C',
      '#FFDAB9',
      '#E0B0FF',
      '#FFA07A',
      '#F7E7CE',
      '#DCAE96',
      '#8E4585',
    ],
    [],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fireworkColors = useMemo(() => rColors, []);
  const letterWidth = isMobile ? 20 : 30;
  const margin = isMobile ? 12 : 20;
  const charWidth = useMemo(() => (isMobile ? mobileCharWidth : desktopCharWidth), [isMobile]);

  const letters = useMemo(
    () => ({
      H: 'M354 -41q-11 0 -24 15q-9 9 -14 40.5t-5 112.5q0 60 3 154q3 98 3 171q0 112 -5 150q-19 -1 -64 -4t-91 -7t-70 -8l-9 -296q-2 -125 -7.5 -209t-11.5 -84q-55 0 -59 48l2 68q9 327 9 630v268q1 220 4.5 294t13.5 83q5 5 12 5q14 0 26 -6t16.5 -14.5t7 -79.5t2.5 -176 l-1 -114q-2 -122 -2 -197q0 -123 2 -144q53 8 107 10q40 1 68.5 5t36 13.5t7.5 108.5q0 131 -12 441q-5 121 -5 180q0 34 2 52t6 24t11 6q21 0 34 -13t20.5 -55.5t11.5 -128.5q3 -76 16 -610l80 5q36 0 36 -20q0 -15 -18 -31.5t-41 -20.5l-60 -11l-8 -324q-3 -139 -7.5 -228 t-10.5 -96t-12 -7z',
      A: 'M170 -16q-8 0 -14 8t-10 37q-17 123 -17 349q0 108 5 218l4 121l-54 4q-37 4 -52 15q-9 6 -9 13q0 3 6.5 9.5t42.5 6.5q50 0 68.5 22.5t27.5 93.5q7 48 29 144.5t59 201.5q84 241 190 241h7q50 0 70 -82.5t26 -308.5l9 -267h63q28 -1 38 -15q4 -6 4 -12q0 -9 -12 -21 t-62 -12h-39l8 -567q0 -75 -2 -113.5t-6.5 -51.5t-11.5 -13l-10 -1q-5 0 -11.5 3t-12 19.5t-9.5 55t-6.5 107t-2.5 176.5q-5 153 -7 256t-4 123l-259 -18q-21 -194 -21 -391l2 -181v-58q0 -83 -9 -101q-5 -11 -18 -11zM221 787q81 8 252 19q0 94 -10 272q-15 260 -35 313 q-6 16 -15 16q-21 0 -58 -88t-74 -222t-50 -232z',
      P: 'M29 -6q-15 0 -20 28q-9 63 -9 336q0 330 13 759q6 200 13 263q6 57 21 67q19 14 34 14q34 0 37 -68l-2 -65l35 50q29 40 72 65.5t81 25.5q45 -1 65 -65t20 -197q-1 -267 -70 -468q-67 -195 -187 -267l-53 -30l-7 -233q0 -169 -21 -208q-13 -7 -22 -7zM92 536q21 0 68 55 q46 51 75.5 126.5t51.5 200.5q18 114 18 225q0 100 -12.5 173t-35.5 73q-10 0 -32 -31t-46 -73q-47 -81 -71.5 -212.5t-34.5 -359.5l-3 -91q0 -86 20 -86h2z',
      Y: 'M187 -16q-12 0 -21 15q-5 13 -10 91q-12 183 -12 386l1 113q0 65 -11 130.5t-39 172.5q-95 352 -95 454q0 16 3 23q7 15 25.5 27.5t31.5 12.5q6 0 8.5 -3t12 -38.5t22 -87t22.5 -103.5q29 -148 54.5 -241.5t37.5 -93.5q2 0 4 5q81 227 129 354t72.5 179.5t36.5 56.5 q19 8 32 8q18 0 18 -17q0 -18 -18.5 -67t-63.5 -156q-58 -143 -115.5 -333.5t-74.5 -225.5q-13 -19 -13 -167q0 -63 2 -154q4 -131 4 -200t-5.5 -94.5t-17.5 -36t-20 -10.5z',
      B: 'M36 -31q-15 0 -25.5 4t-10.5 10t4 13t9 11q14 20 16 702q0 534 8 640q5 65 20 74q21 15 35 15q25 0 30 -47l5 -42l50 53q67 69 137 69q39 0 66 -25q40 -48 40 -160q0 -21 -4.5 -105.5t-63.5 -221.5q-36 -76 -36 -94q0 -7 5.5 -13t28.5 -11q46 -13 69 -73q17 -46 17 -110 q0 -20 -2 -42q-7 -82 -52.5 -190.5t-110 -212.5t-129 -174t-106.5 -70zM110 118q89 107 150 236q39 77 58 132q24 70 24 151q0 84 -26 126q-13 23 -28 23q-19 0 -40 -40q-15 -30 -44 -47.5t-54 -17.5t-25 25q0 6 15.5 35t39.5 65q63 103 105 245q42 146 42 261q0 68 -19 87 q-5 5 -11 5q-23 0 -67 -55q-68 -87 -94 -212q-7 -39 -13 -194t-8 -355z',
      I: 'M92 -32q-19 1 -29 6.5t-10 12.5q0 40 59 43q1 22 1 70q3 205 3 416v366q0 260 5 515q-65 -9 -87 -11q-34 0 -34 20l2 9q19 48 202 55q39 0 57 -10t18 -22q0 -16 -32 -25l-51 -6l-4 -244q-10 -395 -10 -755q0 -367 18 -374q8 -2 18 -2h16q32 0 37 -12q3 -5 3 -12 q0 -12 -14.5 -22.5t-65.5 -14t-102 -3.5z',
      R: 'M37 -13q-13 0 -25 14.5t-12 258.5l1 264l2 359q0 289 2 379q3 102 13 126q5 12 12 16q27 18 37 18q6 0 11 -39.5t7 -97.5q5 -135 9 -161l1 -2q5 0 22.5 26t39.5 69q62 112 137 182.5t129 70.5q26 0 43 -18q22 -16 22 -102v-29q-3 -89 -35.5 -187.5t-90.5 -226.5l-54 -124 l34 -27q22 -16 35 -54t20.5 -119.5t12.5 -227.5q4 -108 4 -175q0 -85 -8.5 -117t-29.5 -37l-6 -1q-19 0 -23 59q-7 82 -10 224q-10 311 -44 363q-8 12 -18 12q-16 0 -49 -27t-46 -27q-8 0 -8 11q0 30 61 143q80 151 137.5 306t57.5 243q0 34 -11 54q-6 10 -17 10 q-41 0 -122 -114.5t-138 -269.5q-31 -101 -43.5 -283t-17.5 -367q-4 -146 -10.5 -249t-21.5 -122q-5 -4 -10 -4z',
      T: 'M381 1q-23 0 -24 25q-8 198 -8 840q0 366 -4 509l-158 1q-101 0 -148 7.5t-47 32.5q0 7 3 15q8 6 80.5 10t180 6.5t213.5 2.5q275 0 293 -12l2 -13q0 -21 -16 -30q-24 -15 -61 -16l-258 -8l2 -378l1 -411q0 -264 -6 -421.5t-26 -157.5q-2 0 -7 -1t-12 -1z',
      D: 'M86 -19q-8 0 -24 7t-45 53q-16 252 -16 1125q0 175 2 212t8 54t17 23q15 11 28 11q5 0 8.5 -4.5t9 -51t9.5 -112.5l9 -154l34 86q45 111 102.5 173.5t114.5 62.5q51 0 80 -115q21 -84 21 -189q0 -39 -3 -82q-21 -227 -106 -536t-201 -520q-11 -23 -28 -36q-9 -7 -20 -7z M94 78q43 90 100 261t104 370t59 373q3 38 3 72q0 122 -36 197q-14 28 -23 28q-8 0 -25 -17q-28 -27 -60.5 -103.5t-57.5 -173.5q-48 -207 -57 -502q-8 -227 -8 -386z',
      S: 'M123 -7q-27 0 -52 25q-24 31 -24 72q0 39 23 65q10 10 17 10q12 0 22 -33q7 -18 19 -30t22 -12q12 0 17 10.5t5 45.5l-3 79q-4 74 -17.5 134t-41.5 132q-110 269 -110 525q0 383 124 432q29 12 51 12q49 0 73 -60.5t30 -189.5q3 -59 3 -94q0 -42 -5.5 -61t-17.5 -33 q-28 -34 -44 -34q-15 0 -20.5 35t-5.5 112q0 104 -13.5 176t-33.5 72t-36 -104.5t-16 -230.5v-30q0 -123 19.5 -217t87.5 -286q51 -153 51 -277q0 -136 -60 -210q-31 -35 -64 -35z',
      N: 'M33 -7q-6 0 -11 2t-8 5t-3 4q-1 8 -5 140q-1 67 -4 154q-2 74 -2 159q0 259 13.5 532.5t30.5 337.5q12 33 36.5 54t46.5 21q14 0 22.5 -11t35.5 -114t62 -250q194 -808 236 -808q10 0 19 606q4 380 8 461q4 123 15 149q5 13 13 18q23 19 36 19q18 0 18 -54q0 -43 -5 -113 q-10 -192 -19 -623q-4 -193 -11 -338.5t-13 -175.5q-7 -25 -20 -46t-28.5 -29.5t-25.5 -8.5q-18 0 -36 28q-33 45 -96.5 249t-136.5 498q-81 319 -99 319q-6 -12 -12.5 -176t-10.5 -404l-6 -404q-2 -136 -11 -171q-9 -30 -29 -30z',
      L: 'M47 -11q-19 0 -27 6t-10 23q-4 24 -7 239.5t-3 497.5q0 209 0.5 341.5t3.5 207.5t10 108t18.5 40t29.5 7q11 0 15.5 -5.5t7.5 -24.5q5 -37 5 -170q0 -151 -5 -479q-3 -211 -3 -373q0 -209 4 -294l1 -24q0 -19 1 -20q28 0 128 10q169 16 219 16q25 0 28 -3.5t3 -12.5 q0 -26 -18 -41q-49 -26 -158 -35.5t-198 -11.5z',
      O: 'M138 0q-32 0 -57 38q-46 67 -63.5 192.5t-17.5 399.5q0 401 41.5 609.5t121.5 208.5q8 0 17 -2t17 -2q16 0 21.5 6.5t22 11t35.5 4.5q90 0 118 -190q5 -39 5 -99q0 -195 -36.5 -507t-81.5 -479q-27 -90 -66 -140.5t-77 -50.5zM163 75q15 0 30 41q40 117 75.5 429 t35.5 538q0 36 -1 68q-10 227 -51 227q-8 0 -18 -10q-30 -34 -58.5 -129t-33.5 -176q-4 -96 -34 -115q-13 -7 -19.5 -29t-9.5 -77q-5 -75 -8 -282q0 -144 12 -249.5t40 -176.5q22 -59 40 -59z',
      V: 'M265 0q-15 0 -30.5 6t-22.5 14q-25 31 -54.5 113t-55.5 190q-41 186 -71.5 487t-30.5 481q0 107 14 131q17 21 29 21q21 0 31.5 -62t16.5 -193q30 -672 130 -958q40 -126 68 -126q25 0 50 100q16 62 44.5 250.5t57 409.5t44.5 382q7 82 12.5 123t12.5 60q16 39 49 39 q15 0 18 -24l1 -17q0 -75 -32 -336t-71 -517.5t-63 -353.5q-64 -220 -147 -220z',
      E: 'M337 -34q-56 0 -102 23q-86 54 -103 166q-7 44 -7 91q0 74 22 183t67.5 230t85.5 190q-1 1 -3 1q-11 3 -43.5 19t-66 53t-46.5 102q-5 21 -5 46q0 173 148 310q93 86 174 89q14 0 32.5 -10t34.5 -24q27 -25 27 -34t-22 -24q-18 -15 -30 -15h-8q-6 0 -27.5 16.5 t-41.5 16.5q-11 0 -32 -9t-72 -68q-62 -73 -81 -166q-6 -30 -6 -58q0 -58 34 -117.5t151 -65.5q59 -4 59 -20q0 -14 -53 -39q-69 -34 -125.5 -164.5t-78.5 -283.5q-9 -61 -9 -114q0 -79 20 -139q39 -94 127 -109q16 -3 31 -3q72 0 139 61q54 50 76 50q12 0 12 -11 q0 -17 -33 -62q-64 -75 -167 -101q-41 -10 -78 -10z',
      U: 'M204 -1q-34 0 -61 28q-69 85 -106 388.5t-37 679.5v62q0 135 4 198.5t17 81.5t40 18q8 0 12.5 -14.5t7.5 -57.5t4 -127t1 -221q0 -343 17.5 -560.5t67.5 -319.5q34 -66 59 -66q23 0 33 49q3 18 10 130t13 272.5t6 313.5q1 252 4 383.5t13 177t31 45.5q25 0 33 -19 q9 -23 9 -135q-9 -579 -24 -844q-13 -214 -33.5 -310t-52.5 -124.5t-68 -28.5z',
    }),
    [],
  );

  const hPath =
    'M12.4267 31.832C9.09333 24.772 8.54666 15.36 14.8267 10.2494C16.7733 8.6667 18.5466 7.88403 20.2132 7.88403C20.7732 7.88403 21.3332 7.97469 21.8799 8.16002C26.8799 9.84536 30.7334 19.056 32.52 26.432C33.04 28.5747 35.6534 29.384 37.8534 29.2187C40.2267 29.0467 41.8 27.8294 41.96 26.04C42.64 18.66 46.7867 10.352 54.4933 8.42535C59.36 7.20802 62.6666 9.01736 64.5733 10.7507C67.9733 13.844 69.68 19.092 68.9333 24.124C67.8133 31.544 63.0666 38.18 58.4799 44.5974C57.6799 45.72 56.8933 46.8294 56.12 47.928L42.4267 67.6464C37.72 62.2574 32.8667 56.9375 27.52 51.1172C26.72 50.2375 25.8932 49.3599 25.0799 48.4774C20.3066 43.3587 15.36 38.0654 12.4267 31.832ZM72.56 6.71736C67.04 1.93336 60.2666 0.0266972 53.4799 1.35203C47.0132 2.61336 41.1333 6.61203 37.2 12.3027C34.0133 6.62403 29.7467 3.16003 24.2267 1.7507C15.2 -0.547971 5.66669 4.2747 2.05335 12.968C-1.67998 21.9787 1.11999 32.936 9.95999 43.82C18.6267 54.5 28.64 64.4708 38.32 74.112L39.6799 75.4615C40.1466 75.925 40.8 76.2454 41.6267 76.4104C42.48 76.735 43.5466 76.936 44.6132 76.936C46.2932 76.936 47.9866 76.4375 48.8666 75.1334C51.36 71.4855 54.0133 67.7787 56.56 64.1959C62.6133 55.7214 68.88 46.9587 73.92 37.7774C80.88 25.1134 80.3733 13.5027 72.56 6.71736Z';

  const hPaths = useMemo(
    () => [
      {
        d: 'M41.1731 114.113C41.3832 116.77 41.5933 119.428 41.8 122.086C42.1333 126.4 45.1733 128.51 48.2799 128.51C51.4266 128.51 54.6267 126.336 55.1333 122.086L55.1366 122.057C55.2289 121.267 55.3213 120.475 55.4267 119.683V119.682L55.5866 118.296C56.1333 118.415 56.6932 118.476 57.2399 118.476C57.5865 118.476 57.9332 118.451 58.2666 118.4V91.0121H73.2266C73.2405 90.941 73.2508 90.8692 73.2613 90.7963C73.2708 90.7297 73.2805 90.6621 73.2932 90.5933C73.4132 89.7814 73.5066 88.9721 73.5866 88.1654C74.7733 76.8241 72.96 66.1334 67.7733 55.7774C66.6133 53.4508 64.64 52.4668 62.6 52.4668C61.08 52.4668 59.5467 53.0081 58.2667 53.9454C56.8933 54.9548 55.8398 56.4227 55.4798 58.1654C55.4665 58.1667 55.4399 58.1681 55.4266 58.1681C53.5333 58.2521 51.6266 59.0908 50.3066 60.6481L49.2 46.5974C49.0133 44.1721 47.48 42.2508 45.5333 41.1241H38.0667C37.08 41.9041 36.36 43.1148 36.1066 44.8241L36.0796 45.0088C35.542 48.6859 35.0045 52.3617 34.4799 56.0374C33.2266 54.2921 31.2534 53.4281 29.2534 53.4281C27.7334 53.4281 26.2134 53.9228 24.9867 54.9014C24.7467 52.3374 24.48 49.7761 24.1867 47.2161C23.9067 44.7761 22.2666 42.8148 20.24 41.6814C20.2266 41.4921 20.2133 41.3068 20.2 41.1241C20.0933 40.0628 19.7466 39.1068 19.2266 38.2761C17.8399 36.0188 15.1999 34.6868 12.7466 34.6868C11.0533 34.6868 9.42671 35.3308 8.38671 36.7561C7.85338 37.4721 7.4665 38.3841 7.27983 39.5121C6.5865 43.8614 5.99989 48.2147 5.53322 52.5734V52.5744C4.27997 64.2168 3.88003 75.8991 4.42668 87.6574C4.42668 87.8294 4.43999 87.9987 4.46665 88.1654C4.77332 90.5683 6.3866 92.3829 8.3866 93.3709C9.47994 93.9173 10.7067 94.2105 11.8934 94.2105C12.44 94.2105 12.9867 94.148 13.4934 94.0198C13.4934 95.8454 13.48 97.6709 13.4534 99.4974C13.4 103.763 16.5333 105.927 19.8 105.927C21.7867 105.927 23.84 105.126 25.24 103.507L25.96 114.607C26.2267 118.604 30.1067 121.191 33.5867 121.191C36.1867 121.191 38.5734 119.751 39.0534 116.38C39.56 112.969 40.0533 109.559 40.5466 106.146C40.7532 108.802 40.9631 111.458 41.1731 114.113Z',
        fill: '#FFCEB8',
      },
      {
        d: 'M58.2666 91.0121V118.4C60.5199 118.064 62.4534 116.592 62.92 113.696C63.9334 107.486 64.8267 101.263 65.6 95.0256C66.3733 95.284 67.1733 95.4189 67.9466 95.4189C70.3866 95.4189 72.6266 94.0881 73.2266 91.0121H58.2666Z',
        fill: '#FFCEB8',
      },
      {
        d: 'M38.0667 41.1241H45.5333C44.28 40.4054 42.8666 40.0094 41.5199 40.0094C40.2399 40.0094 39.0267 40.3601 38.0667 41.1241Z',
        fill: '#FFCEB8',
      },
      {
        d: 'M12.4267 74.832C9.09333 67.772 8.54666 58.36 14.8267 53.2494C16.7733 51.6667 18.5466 50.884 20.2132 50.884C20.7732 50.884 21.3332 50.9747 21.8799 51.16C26.8799 52.8454 30.7334 62.056 32.52 69.432C33.04 71.5747 35.6534 72.384 37.8534 72.2187C40.2267 72.0467 41.8 70.8294 41.96 69.04C42.64 61.66 46.7867 53.352 54.4933 51.4254C59.36 50.208 62.6666 52.0174 64.5733 53.7507C67.9733 56.844 69.68 62.092 68.9333 67.124C67.8133 74.544 63.0666 81.18 58.4799 87.5974C57.6799 88.72 56.8933 89.8294 56.12 90.928L42.4267 110.646C37.72 105.257 32.8667 99.9375 27.52 94.1172C26.72 93.2375 25.8932 92.3599 25.0799 91.4774C20.3066 86.3587 15.36 81.0654 12.4267 74.832ZM72.56 49.7174C67.04 44.9334 60.2666 43.0267 53.4799 44.352C47.0132 45.6134 41.1333 49.612 37.2 55.3027C34.0133 49.624 29.7467 46.16 24.2267 44.7507C15.2 42.452 5.66669 47.2747 2.05335 55.968C-1.67998 64.9787 1.11999 75.936 9.95999 86.82C18.6267 97.5 28.64 107.471 38.32 117.112L39.6799 118.461C40.1466 118.925 40.8 119.245 41.6267 119.41C42.48 119.735 43.5466 119.936 44.6132 119.936C46.2932 119.936 47.9866 119.437 48.8666 118.133C51.36 114.485 54.0133 110.779 56.56 107.196C62.6133 98.7214 68.88 89.9587 73.92 80.7774C80.88 68.1134 80.3733 56.5027 72.56 49.7174Z',
        fill: '#E91E63',
      },
      {
        d: 'M55.0533 18.5654C53.0133 18.5654 51.1866 17.1894 50.4266 15.2148C49.12 11.8001 48.9866 7.81876 50.2132 4.36143C50.9732 2.23076 52.6265 0.586769 54.8799 0.586769C55.2265 0.586769 55.5866 0.628094 55.9732 0.712094C58.2799 1.22943 60.4932 4.00809 59.6132 6.46276C58.7732 8.83476 58.7999 10.1681 59.6132 12.2841C60.5465 14.7241 58.8533 17.5814 56.4933 18.3388C56 18.4934 55.5333 18.5654 55.0533 18.5654Z',
        fill: '#FFCEB8',
      },
      {
        d: 'M80.1867 26.2054C79.8267 26.2054 79.4666 26.1654 79.0933 26.0828C76.76 25.5601 74.5999 22.7948 75.4399 20.3308C76.6533 16.8134 77.8666 13.2974 79.0666 9.78144C79.7999 7.6441 81.4933 6.00811 83.7333 6.00811C84.0799 6.00811 84.4533 6.04811 84.8266 6.13211C87.16 6.65477 89.3199 9.41877 88.4666 11.8828C87.2666 15.4001 86.0533 18.9161 84.8533 22.4321C84.1067 24.5708 82.4267 26.2054 80.1867 26.2054Z',
        fill: '#FFCEB8',
      },
      {
        d: 'M100.293 37.6681C100.88 39.4748 102.907 41.1015 104.907 41.1015C105.4 41.1015 105.88 41.0055 106.347 40.7921C107.773 40.1401 109.093 39.3761 110.307 38.5028V22.1455C109.613 22.7321 109.067 23.5735 108.787 24.6961C108.093 27.5855 106.2 30.3388 103.427 31.6135C101.067 32.6975 99.4399 34.9761 100.293 37.6681Z',
        fill: '#FFCEB8',
      },
      {
        d: 'M113.16 36.0454C112.293 36.9427 111.333 37.7615 110.307 38.5028V22.1455C111.12 21.4708 112.12 21.1334 113.16 21.0934C113.227 21.0908 113.293 21.0895 113.373 21.0895C116.187 21.0895 119.04 23.2721 118.187 26.7961C117.32 30.4414 115.573 33.5414 113.16 36.0454Z',
        fill: '#FFCEB8',
      },
    ],
    [],
  );

  useEffect(() => {
    if (!svgRef.current) return;

    const svg = d3.select(svgRef.current);
    const width = window.innerWidth;
    const height = window.innerHeight;

    svg.attr('width', width).attr('height', height).attr('viewBox', `0 0 ${width} ${height}`);

    const gridAnimationGroup = svg.append('g');
    // const cardsGroup = svg.append('g');
    const fireworksGroup = svg.append('g');
    const confettiGroup = svg.append('g');
    const messageGroup = svg.append('g');
    const balloonGroup = svg.append('g');

    const createGridAnimation = (svgElement, width, height, particleCount = 5) => {
      const svg = d3.select(svgElement);

      // Grid parameters
      const cellSize = 50;
      const rows = Math.floor(height / cellSize);
      const cols = Math.floor(width / cellSize);

      // Create grid
      const grid = gridAnimationGroup.append('g').attr('class', 'grid');

      for (let i = 0; i <= rows; i++) {
        grid
          .append('line')
          .attr('x1', 0)
          .attr('y1', i * cellSize)
          .attr('x2', width)
          .attr('y2', i * cellSize)
          .attr('stroke', '#ddd')
          .attr('stroke-width', 0.5);
      }

      for (let j = 0; j <= cols; j++) {
        grid
          .append('line')
          .attr('x1', j * cellSize)
          .attr('y1', 0)
          .attr('x2', j * cellSize)
          .attr('y2', height)
          .attr('stroke', '#ddd')
          .attr('stroke-width', 0.5);
      }

      // Create particles
      const particles = svg
        .append('g')
        .attr('class', 'grid-particles')
        .selectAll('circle')
        .data(d3.range(particleCount))
        .enter()
        .append('circle')
        .attr('r', 5)
        .attr('fill', (d, i) => tColors[i % 5]) // Use different colors for particles
        .attr('cx', () => Math.floor(Math.random() * cols) * cellSize)
        .attr('cy', () => Math.floor(Math.random() * rows) * cellSize);

      function moveParticle(particle) {
        const currentX = parseFloat(particle.attr('cx'));
        const currentY = parseFloat(particle.attr('cy'));

        const directions = [
          { dx: cellSize, dy: 0 },
          { dx: -cellSize, dy: 0 },
          { dx: 0, dy: cellSize },
          { dx: 0, dy: -cellSize },
        ];

        const validDirections = directions.filter((dir) => {
          const newX = currentX + dir.dx;
          const newY = currentY + dir.dy;
          return newX >= 0 && newX <= width && newY >= 0 && newY <= height;
        });

        if (validDirections.length > 0) {
          const { dx, dy } = validDirections[Math.floor(Math.random() * validDirections.length)];

          particle
            .transition()
            .duration(500)
            .ease(d3.easeLinear)
            .attr('cx', currentX + dx)
            .attr('cy', currentY + dy)
            .on('end', () => moveParticle(particle));
        } else {
          // If no valid directions, reset to a random position
          particle
            .attr('cx', Math.floor(Math.random() * cols) * cellSize)
            .attr('cy', Math.floor(Math.random() * rows) * cellSize);
          moveParticle(particle);
        }
      }

      // Start the animation for each particle
      particles.each(function () {
        moveParticle(d3.select(this));
      });

      // Return a function to stop the animation if needed
      return function stopAnimation() {
        particles.interrupt();
        particles.remove();
      };
    };

    function createBalloon() {
      const balloon = balloonGroup.append('g');
      const x = Math.random() * width;
      const y = height + 50;
      const colorSet = colors[Math.floor(Math.random() * colors.length)];
      const size = Math.random() * 30 + 30; // Random size between 30 and 60

      const gradientId = `balloonGradient-${Date.now()}`;
      const gradient = balloon
        .append('defs')
        .append('radialGradient')
        .attr('id', gradientId)
        .attr('cx', '35%')
        .attr('cy', '35%')
        .attr('r', '60%');

      gradient.append('stop').attr('offset', '0%').attr('stop-color', colorSet.light);
      gradient.append('stop').attr('offset', '100%').attr('stop-color', colorSet.main);

      // Create a hand-drawn heart shape
      const heartPath = d3.path();
      heartPath.moveTo(x, y);

      // Left curve of the heart
      heartPath.bezierCurveTo(x - size * 0.5, y - size * 0.3, x - size, y - size * 0.8, x, y - size);

      // Right curve of the heart
      heartPath.bezierCurveTo(x + size, y - size * 0.8, x + size * 0.5, y - size * 0.3, x, y);

      // Add some "hand-drawn" imperfections
      heartPath.lineTo(x + (Math.random() - 0.5) * size * 0.1, y + (Math.random() - 0.5) * size * 0.1);
      heartPath.lineTo(x + (Math.random() - 0.5) * size * 0.1, y - size * 0.9 + (Math.random() - 0.5) * size * 0.1);

      balloon
        .append('path')
        .attr('d', heartPath.toString())
        .attr('fill', `url(#${gradientId})`)
        .attr('stroke', colorSet.main)
        .attr('stroke-width', 2)
        .style('filter', 'url(#hand-drawn-filter)');

      // Add a string to the heart
      const stringPath = d3.path();
      stringPath.moveTo(x, y);
      stringPath.quadraticCurveTo(
        x + (Math.random() - 0.5) * 20,
        y + 30 + Math.random() * 10,
        x + (Math.random() - 0.5) * 10,
        y + 60 + Math.random() * 20,
      );

      balloon
        .append('path')
        .attr('d', stringPath.toString())
        .attr('stroke', 'black')
        .attr('stroke-width', 1.5)
        .attr('fill', 'none')
        .style('filter', 'url(#hand-drawn-filter)');

      // Add subtle animation to simulate floating
      const floatAnimation = () => {
        balloon
          .transition()
          .duration(2000 + Math.random() * 1000)
          .attr('transform', `translate(${(Math.random() - 0.5) * 10}, ${(Math.random() - 0.5) * 10})`)
          .on('end', floatAnimation);
      };

      floatAnimation();

      // Main upward animation
      balloon
        .transition()
        .duration(15000 + Math.random() * 5000)
        .attr('transform', `translate(${Math.random() * 100 - 50}, ${-height - 150})`)
        .ease(d3.easeQuadInOut)
        .on('end', () => {
          balloon.remove();
          createBalloon();
        });
    }

    function createFirework(x, y) {
      const particles = 50;
      const firework = fireworksGroup.append('g');

      for (let i = 0; i < particles; i++) {
        const angle = ((Math.PI * 2) / particles) * i;
        const velocity = Math.random() * 3 + 2;

        firework
          .append('circle')
          .attr('cx', x)
          .attr('cy', y)
          .attr('r', 2)
          .attr('fill', fireworkColors[Math.floor(Math.random() * fireworkColors.length)])
          .transition()
          .duration(1500)
          .ease(d3.easeQuadOut)
          .attr('cx', x + Math.cos(angle) * 100 * velocity)
          .attr('cy', y + Math.sin(angle) * 100 * velocity)
          .attr('r', 0)
          .remove();
      }

      setTimeout(() => firework.remove(), 1500);
    }

    let confettiData = [];

    function createConfetti() {
      const newConfetti = d3.range(5).map(() => ({
        x: Math.random() * width,
        y: -20,
        rotation: Math.random() * 360,
        color: fireworkColors[Math.floor(Math.random() * fireworkColors.length)],
        speed: Math.random() * 10 + 1,
      }));

      confettiData = [...confettiData, ...newConfetti];
    }

    function updateConfetti() {
      const confetti = confettiGroup.selectAll('rect').data(confettiData, (d, i) => i);

      confetti
        .enter()
        .append('rect')
        .attr('width', 10)
        .attr('height', 10)
        .merge(confetti)
        .attr('x', (d) => d.x)
        .attr('y', (d) => Math.min(d.y, height - 10)) // Ensure confetti doesn't go below screen
        .attr('fill', (d) => d.color)
        .attr('transform', (d) => {
          const y = Math.min(d.y, height - 10);
          return `rotate(${d.rotation}, ${d.x}, ${y})`;
        });

      confetti.exit().remove();

      // Update confetti data
      confettiData = confettiData.map((d) => {
        if (d.y >= height - 10) {
          // If confetti has reached the bottom, stop its vertical movement
          return { ...d, y: height - 10, speed: 0 };
        }
        return d;
      });

      // Spread confetti horizontally at the bottom
      const bottomConfetti = confettiData.filter((d) => d.y === height - 10);
      bottomConfetti.forEach((d) => {
        if (Math.random() < 0.1) {
          // 10% chance to move each frame
          d.x += Math.random() * 2 - 1; // Move left or right by up to 1 pixel
          d.x = Math.max(0, Math.min(d.x, width - 10)); // Keep within screen bounds
        }
      });

      // Remove excess confetti if there's too much
      const maxConfetti = 10000; // Adjust this value based on performance
      if (confettiData.length > maxConfetti) {
        confettiData = confettiData.slice(-maxConfetti);
      }
    }

    const writeBDayMessage = () => {
      const screenWidth = window.innerWidth;
      const boxSize = isMobile ? 340 : 698;

      let xOffset = (screenWidth - boxSize) / 2;
      const mobileOffset = isMobile ? 5 : 0;

      'HAPPY BIRTHDAY SANYA'.split('').forEach((char, i) => {
        if (char === ' ') {
          xOffset += letterWidth - mobileOffset;
          return;
        }

        const g = messageGroup
          .append('g')
          .attr('class', 'letter')
          .attr('d-name', char)
          .style(
            'transform',
            `translate(${xOffset}px, ${isMobile ? '400px' : '500px'}) scale(${isMobile ? '0.02' : '0.05'})`,
          )
          .style('opacity', 0);

        const path = g
          .append('path')
          .attr('d', letters[char])
          .attr('stroke', '#E91E63')
          .attr('stroke-width', 40)
          .attr('stroke-linecap', 'round')
          .attr('stroke-linejoin', 'round')
          .style('transform', 'scaleX(-1) rotate(180deg)')
          .attr('fill', '#FFCEB8');

        const length = path.node().getTotalLength();
        path.attr('stroke-dasharray', `${length} ${length}`).attr('stroke-dashoffset', length);

        g.transition()
          .delay(i * 300)
          .duration(100)
          .style('opacity', 1);

        path
          .transition()
          .delay(i * 300)
          .duration(600)
          .ease(d3.easeLinear)
          .attr('stroke-dashoffset', 0);

        xOffset += charWidth[char] + margin / 2 - mobileOffset;
      });

      const heart = svg
        .append('g')
        .attr('class', 'hfhfh')
        .style(
          'transform',
          `translate(${xOffset}px, ${isMobile ? '340px' : '400px'}) scale(${isMobile ? '0.2' : '0.3'})`,
        )
        .style('opacity', 0);

      hPaths.forEach((p) => {
        const path = heart.append('path').attr('d', p.d).attr('fill', p.fill).attr('stroke', 0);
        const length = path.node().getTotalLength();
        path.attr('stroke-dasharray', `${length} ${length}`).attr('stroke-dashoffset', length);

        heart.transition().delay(6000).duration(1000).style('opacity', 1);

        path.transition().delay(6000).duration(1000).ease(d3.easeLinear).attr('stroke-dashoffset', 0);
      });
    };

    const writeLoveMessage = () => {
      const screenWidth = window.innerWidth;
      const boxSize = isMobile ? 212 : 365;

      let xOffset = (screenWidth - boxSize) / 2;

      'I LOVE YOUT'.split('').forEach((char, i) => {
        if (char === ' ') {
          xOffset += letterWidth;
          return;
        }

        const g = messageGroup
          .append('g')
          .attr('class', 'letter')
          .attr('d-name', char)
          .style(
            'transform',
            char === 'T'
              ? `translate(${xOffset}px, ${isMobile ? '464px' : '616px'}) scale(${isMobile ? '0.2' : '0.3'})`
              : `translate(${xOffset}px, ${isMobile ? '480px' : '640px'}) scale(${isMobile ? '0.03' : '0.05'})`,
          )
          .style('opacity', 0);

        const path = g
          .append('path')
          .attr('d', char === 'T' ? hPath : letters[char])
          .attr('stroke', '#E91E63')
          .attr('stroke-width', char === 'T' ? 2 : 40)
          .attr('stroke-linecap', 'round')
          .attr('stroke-linejoin', 'round')
          .style('transform', char === 'T' ? '' : 'scaleX(-1) rotate(180deg)')
          .attr('fill', '#E91E63')
          .style('fill-opacity', char === 'T' ? '1' : '0.8');

        const length = path.node().getTotalLength();
        path.attr('stroke-dasharray', `${length} ${length}`).attr('stroke-dashoffset', length);

        g.transition()
          .delay(i * 300)
          .duration(100)
          .style('opacity', 1);

        path
          .transition()
          .delay(i * 300)
          .duration(600)
          .ease(d3.easeLinear)
          .attr('stroke-dashoffset', 0);

        xOffset += charWidth[char === 'T' ? 50 : char] + margin / 2;
      });
    };

    // function addHandPaintedTextBoxes(svgElement, width, height) {
    //   const textBoxes = [
    //     { text: "Love", color: "#FFC0CB" },  // Light gold
    //     { text: "US!", color: "#E0B0FF" },  // Pale green
    //     { text: "Number 15", color: "#FFA07A" },  // Light salmon
    //     { text: "Passion", color: "#DCAE96" }  // Light sky blue
    //   ];

    //   const boxGroup = cardsGroup.append('g').attr('class', 'text-boxes');

    //   const margin = 60; // Margin from the edges
    //   const boxWidth = 150;
    //   const boxHeight = 80;

    //   // Define corner positions
    //   const corners = [
    //     { x: margin, y: margin }, // Top-left
    //     { x: width - boxWidth - margin, y: margin }, // Top-right
    //     { x: margin, y: height - boxHeight - margin }, // Bottom-left
    //     { x: width - boxWidth - margin, y: height - boxHeight - margin } // Bottom-right
    //   ];

    //   const boxes = textBoxes.map((box, index) => {
    //     const { x, y } = corners[index % corners.length];

    //     const group = boxGroup.append('g')
    //       .attr('transform', `translate(${x}, ${y})`);

    //     // Create hand-painted rectangle
    //     group.append('path')
    //       .attr('d', createHandPaintedRect(0, 0, boxWidth, boxHeight, 8))
    //       .attr('fill', box.color)
    //       .attr('stroke', '#000')
    //       .attr('stroke-width', 2)
    //       .style('fill-opacity', '0.7')
    //       .style('filter', 'url(#hand-painted-filter)');

    //     // Add text
    //     group.append('text')
    //       .attr('x', boxWidth / 2)
    //       .attr('y', boxHeight / 2)
    //       .attr('text-anchor', 'middle')
    //       .attr('dominant-baseline', 'central')
    //       .text(box.text)
    //       .attr('font-family', 'Comic Sans MS, cursive')
    //       .attr('font-size', '24px')
    //       .attr('fill', '#000')
    //       .style('filter', 'url(#hand-painted-filter)');

    //     // Add subtle animations
    //     animateBox(group);

    //     return group;
    //   });

    //   // Create hand-painted filter if it doesn't exist
    //   if (!cardsGroup.select('#hand-painted-filter').node()) {
    //     const filter = cardsGroup.append('defs')
    //       .append('filter')
    //       .attr('id', 'hand-painted-filter');

    //     filter.append('feTurbulence')
    //       .attr('type', 'fractalNoise')
    //       .attr('baseFrequency', 0.02)
    //       .attr('numOctaves', 3)
    //       .attr('result', 'noise');

    //     filter.append('feDisplacementMap')
    //       .attr('in', 'SourceGraphic')
    //       .attr('in2', 'noise')
    //       .attr('scale', 3)
    //       .attr('xChannelSelector', 'R')
    //       .attr('yChannelSelector', 'G');
    //   }

    //   // Return a cleanup function
    //   return function cleanup() {
    //     boxes.forEach(box => box.remove());
    //     if (boxGroup.empty()) {
    //       cardsGroup.select('#hand-painted-filter').remove();
    //     }
    //   };
    // }

    // function createHandPaintedRect(x, y, width, height, distortion) {
    //   const p = d3.path();
    //   p.moveTo(x + randDist(distortion), y + randDist(distortion));
    //   p.lineTo(x + width + randDist(distortion), y + randDist(distortion));
    //   p.lineTo(x + width + randDist(distortion), y + height + randDist(distortion));
    //   p.lineTo(x + randDist(distortion), y + height + randDist(distortion));
    //   p.closePath();
    //   return p.toString();
    // }

    // function randDist(distance) {
    //   return (Math.random() - 0.5) * distance * 2;
    // }

    // function animateBox(group) {
    //   function animate() {
    //     const duration = 2000 + Math.random() * 2000;
    //     const rotateAngle = (Math.random() - 0.5) * 5;
    //     const scaleAmount = 0.95 + Math.random() * 0.1;

    //     group.transition()
    //       .duration(duration)
    //       .attr('transform', `${group.attr('transform')} rotate(${rotateAngle}) scale(${scaleAmount})`)
    //       .on('end', animate);
    //   }

    //   animate();
    // }

    function animate() {
      if (Math.random() < 0.1) createFirework(Math.random() * width, Math.random() * height * 0.7);
      if (confettiData.length < 100) createConfetti();

      confettiData.forEach((d) => {
        d.y += d.speed;
        d.rotation += d.speed * 2;
      });

      updateConfetti();

      animationRef.current = requestAnimationFrame(animate);
    }

    // Create initial balloons
    for (let i = 0; i < 4; i++) {
      setTimeout(createBalloon, i * 1500);
    }

    const bMessageTimeout = setTimeout(() => {
      writeBDayMessage();
    }, 6000);

    const lMessageTimeout = setTimeout(() => {
      writeLoveMessage();
    }, 12000);

    animationRef.current = requestAnimationFrame(animate);
    gridRef.current = createGridAnimation(svgRef.current, width, height);
    // let cancelAnimation = null
    // const animateTimeout = setTimeout(() => {
    //   cancelAnimation = addHandPaintedTextBoxes(svgRef.current, width, height);
    // }, 18000);

    return () => {
      cancelAnimationFrame(animationRef.current);
      clearTimeout(bMessageTimeout);
      clearTimeout(lMessageTimeout);
      // clearTimeout(animateTimeout);
      gridRef.current();
      // if (cancelAnimation) {
      //   cancelAnimation();
      // }
    };
  }, [charWidth, colors, fireworkColors, hPaths, isMobile, letterWidth, letters, margin, tColors]);

  return (
    <div className="h-screen w-screen h-s overflow-hidden">
      <svg ref={svgRef} className="w-screen h-screen"></svg>
    </div>
  );
};
